import React from 'react';
import { Form, Image } from 'react-bootstrap';
import { IDesignElements } from '../../interfaces/brand-magic.interface';
import { useAppDispatch, useAppSelector } from '../../store/store';
import {
    useRemoveBrandElementsLogoMutation,
    useUploadBrandElementsLogoMutation,
} from '../../store/api/brandMagic.api';
import { SetDesignElementsLogo } from '../../store/slice/brand-elements.slice';
import { getActiveBrand } from '../../store/selector/brand.selector';
import { displaySuccessToast, displayWarningToast } from '../../utils/ToastUtils';

interface IProps {
    designElementsData: IDesignElements | null;
}

const DesignElementsLogo = ({ designElementsData }: IProps) => {
    const dispatch = useAppDispatch();
    const activeBrand = useAppSelector(getActiveBrand);
    const [uploadLogo, { isLoading: uploadLogoLoading }] = useUploadBrandElementsLogoMutation();
    const [deleteLogo, { isLoading: removeLogoLoading }] = useRemoveBrandElementsLogoMutation();

    // handle file input change
    const handleFileInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const fileInput = event.target;
        const fileList = fileInput.files;
        if (fileList && fileList.length > 0 && activeBrand) {
            const file = fileList[0];
            const response = await uploadLogo({ logo: file, brandId: activeBrand.id });
            if (response && 'data' in response) {
                const data = response.data;
                dispatch(SetDesignElementsLogo(data.logo));
            }
        }
    };

    // handle delete logo
    const handleDelete = async () => {
        if (!activeBrand) return;
        await deleteLogo(activeBrand.id)
            .then(() => {
                dispatch(SetDesignElementsLogo(null));
                displaySuccessToast('Successfully deleted');
            })
            .catch(() => displayWarningToast('There was an error'));
    };

    return (
        <div className="designElements mb-3 p-3">
            <h1 className="fw-bold text-primary mb-1">Logo</h1>
            <span className="h5 text-light text-center m-0 fw-regular mb-3">
                Preferred: square image with transparent background | Accepted formats: JPG, PNG,
                SVG
            </span>

            <div className="d-flex align-items-center justify-contents-center mt-3">
                {uploadLogoLoading ? (
                    <div className="SpinnerDiv">
                        {/* Place your spinner component or loading indicator here */}
                    </div>
                ) : (
                    <>
                        {!designElementsData || !designElementsData.logo ? (
                            <Form.Group className="form-group me-3">
                                <label htmlFor="fileInputLogo" className="">
                                    <div className="d-flex justify-content-center align-items-center flex-column uploadLogo">
                                        <i className="ph ph-cloud-arrow-up lg"></i>
                                        <p className="h4 text-light mb-1">Add logo</p>
                                    </div>
                                </label>
                                <input
                                    id="fileInputLogo"
                                    type="file"
                                    className="file-input"
                                    onChange={handleFileInputChange}
                                    onClick={(e) => {
                                        if (designElementsData && designElementsData.logo) {
                                            e.preventDefault();
                                            displayWarningToast(
                                                'Delete the current logo to add a new one',
                                            );
                                        }
                                    }}
                                    multiple={false}
                                />
                            </Form.Group>
                        ) : null}
                    </>
                )}

                <>
                    {designElementsData && designElementsData.logo && (
                        <div>
                            {removeLogoLoading ? (
                                <div className="SpinnerDiv">
                                    {/* <Spinner animation="border" className="custom-spinner" /> */}
                                </div>
                            ) : (
                                <>
                                    <div className="">
                                        <div className="uploadedLogo">
                                            <Image
                                                src={designElementsData.logo}
                                                className="border border-primary rounded p-3 "
                                            />
                                            <button
                                                className="iconbtn iconbtn-transparent"
                                                onClick={() => handleDelete()}
                                            >
                                                <i className="ph-bold ph-prohibit-inset"></i>
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </>
            </div>
        </div>
    );
};

export default DesignElementsLogo;
